import { css } from 'styled-components';
export const mediaHover = (style) => css `
    @media (hover: hover) {
      :hover {
        ${style}
      }
    }
  `;
//# sourceMappingURL=utils.js.map